/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { ChangeEvent } from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import { TextFieldProps } from "@mui/material";
import { useTranslation } from "../../Internationalisierung/i18nBasis";
import StringUtil from "../../Utils/StringUtil";
import InputBaseProps from "../InputBase/InputBaseProps";
import TextInput from "../TextInput";

export interface DezimalInputProps extends InputBaseProps {
    value: number | null;
    onChange: (value: number | null) => void;
    onBlur?: () => void;
    sx?: TextFieldProps["sx"];
}

export interface DezimalFormatProps extends NumericFormatProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const DezimalFormat = React.forwardRef<typeof NumericFormat, DezimalFormatProps>(function (props, ref) {
    const { onChange, ...other } = props;
    const { decimalSeparator } = useTranslation({ withFormatParts: true });
    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            decimalSeparator={decimalSeparator}
            decimalScale={8}
            valueIsNumericString
        />
    );
});

export default function DezimalInput(props: DezimalInputProps) {
    function aendern(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const newValue = e.target.value;
        props.onChange(StringUtil.isEmpty(newValue) ? null : Number(newValue));
    }

    return (
        <TextInput
            {...props}
            value={props.value?.toString()}
            onChange={aendern}
            onBlur={props.onBlur}
            InputProps={{
                inputComponent: DezimalFormat as any
            }}
        />
    );
}
